import React from "react";

export default function OffCanvas({
  panel,
  headRight,
  children,
  filtre,
  recherche,
}) {
  return (
    <>
      <div className="tyn-aside tyn-aside-base">
        <div className="tyn-aside-head">
          <div className="tyn-aside-head-text">
            <h1 className="tyn-aside-title">{panel}</h1>
          </div>
          {headRight}
        </div>
        {filtre}
        <div className="tyn-aside-body" data-simplebar>
          {recherche}
          <div className="tab-content">
            <div
              className="tab-pane show active"
              id="all-chats"
              tabIndex="0"
              role="tabpanel"
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
